"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftMatchDto = instanceOfShiftMatchDto;
exports.ShiftMatchDtoFromJSON = ShiftMatchDtoFromJSON;
exports.ShiftMatchDtoFromJSONTyped = ShiftMatchDtoFromJSONTyped;
exports.ShiftMatchDtoToJSON = ShiftMatchDtoToJSON;
exports.ShiftMatchDtoToJSONTyped = ShiftMatchDtoToJSONTyped;
const ShiftViewDto_1 = require("./ShiftViewDto");
const ShiftMatchProfileDto_1 = require("./ShiftMatchProfileDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
/**
 * Check if a given object implements the ShiftMatchDto interface.
 */
function instanceOfShiftMatchDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('requestStatus' in value) || value['requestStatus'] === undefined)
        return false;
    if (!('notifiedAt' in value) || value['notifiedAt'] === undefined)
        return false;
    if (!('views' in value) || value['views'] === undefined)
        return false;
    return true;
}
function ShiftMatchDtoFromJSON(json) {
    return ShiftMatchDtoFromJSONTyped(json, false);
}
function ShiftMatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoFromJSON)(json['nurseProfile']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'hasExpiredCredentialsInGracePeriod': json['hasExpiredCredentialsInGracePeriod'] == null ? undefined : json['hasExpiredCredentialsInGracePeriod'],
        'notifiedAt': (json['notifiedAt'] == null ? null : new Date(json['notifiedAt'])),
        'views': (json['views'].map(ShiftViewDto_1.ShiftViewDtoFromJSON)),
    };
}
function ShiftMatchDtoToJSON(json) {
    return ShiftMatchDtoToJSONTyped(json, false);
}
function ShiftMatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoToJSON)(value['nurseProfile']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'hasExpiredCredentialsInGracePeriod': value['hasExpiredCredentialsInGracePeriod'],
        'notifiedAt': (value['notifiedAt'] == null ? null : value['notifiedAt'].toISOString()),
        'views': (value['views'].map(ShiftViewDto_1.ShiftViewDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftMatchDto.js.map